<template>
  <div class="transaction-history">
    <div class="dashboard-container">
      <div class="transaction-info">
        <div class="left">
          <p>Amount transactioned</p>
          <div class="amount"><span class="usd me-2">$</span>{{ transactioned|formatDollars }}</div>
        </div>
        <div class="right">
          <p>Number of transactions</p>
          <div class="amount transaction-num">{{ numberTransactions }}</div>
        </div>
      </div>
      <div class="transactions box-style">
        <div class="top d-flex align-items-center justify-content-between">
          <h3>Withdraws</h3>
          <div class="select">
            <select name="transaction-period" v-model="form.period">
              <option value="7">7-days</option>
              <option value="30">30-days</option>
              <option value="60">60-days</option>
            </select>
          </div>
        </div>
        <div class="transaction" v-for="t in transactions" :key="t.id">
          <div class="transaction-details">
            <div class="id d-flex align-items-center">
              <p>ID</p>
              <p class="ms-4">{{ t.id|shortUuid }}</p>
            </div>
            <div class="date">
              <p>{{ t.created|formatDate }}</p>
            </div>
          </div>
          <div class="transaction-status">
            <div class="status text-capitalize" :class="t.status">{{ t.status }}</div>
            <div class="value">$ {{ t.amount|formatDollars }}</div>
          </div>
        </div>
        <div class="text-center" v-if="transactions.length === 0"><h2>No transactions</h2></div>
      </div>
    </div>
  </div>
</template>

<script>
import {Transaction} from "@/models"

import API from "@/api"
const api = new API()
export default {
  name: "Transactions",
  data() {
    return {
      form: {
        period: 7
      },
      stats: []
    }
  },
  watch: {
    'form.period': function() {
      this.fetchTransactions()
    }
  },
  mounted() {
    this.fetchTransactions()
  },
  computed: {
    transactions() {
      return Transaction.all()
    },
    transactioned() {
      return Transaction.query().where('status', 'completed').sum('amount')
    },
    numberTransactions() {
      return Transaction.query().where('status', 'completed').count()
    }
  },
  methods: {
    fetchTransactions() {
      this.$wait.start('transactions_fetch')
      api.getTransactions(this.form.period)
        .then(r => {
          Transaction.deleteAll().then(() => Transaction.insertOrUpdate({
            data: r.data.results
          }))
        })
        .catch(e => console.log(e))
        .finally(() => this.$wait.end('transactions_fetch'))
    }
  }
}
</script>
